import { types } from '../actions/timesheetOffline';

const initialState = {
  offlineDraftSaved: null, // { timesheetId, savedAt }
  offlineQueueCount: 0, // number of queued submissions
  isSyncing: false, // syncing in progress
  lastSyncedCount: 0, // how many synced on last sync
  pushPermission: 'default', // 'default' | 'granted' | 'denied'
  isPushSubscribed: false // is user subscribed to push
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.SET_OFFLINE_DRAFT_SAVED:
      return {
        ...state,
        offlineDraftSaved: action.payload
      };
    case types.SET_OFFLINE_QUEUE_COUNT:
      return {
        ...state,
        offlineQueueCount: action.payload
      };
    case types.SET_SYNCING:
      return {
        ...state,
        isSyncing: action.payload
      };
    case types.SET_SYNC_COMPLETE:
      return {
        ...state,
        isSyncing: false,
        lastSyncedCount: action.payload
      };
    case types.SET_PUSH_PERMISSION:
      return {
        ...state,
        pushPermission: action.payload
      };
    case types.SET_PUSH_SUBSCRIBED:
      return {
        ...state,
        isPushSubscribed: action.payload
      };
    default:
      return state;
  }
}
